import React from "react";

const ConfirmModal = ({ isOpen, title, message, confirmLabel = "Confirm", confirmStyle = "primary", onConfirm, onCancel }) => {
  if (!isOpen) return null;

  const confirmBtnStyle = {
    padding: "0.45rem 1rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
    background: confirmStyle === "danger" ? "#dc2626" : "#001272",
    color: "white",
  };

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "white", borderRadius: "0.5rem", padding: "1.5rem",
          width: "100%", maxWidth: "380px", boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          margin: "1rem",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ fontSize: "1.05rem", fontWeight: "700", color: "#001272", marginBottom: "0.75rem" }}>
          {title}
        </h2>
        <p style={{ fontSize: "0.875rem", color: "#374151", marginBottom: "1.25rem" }}>
          {message}
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
          <button
            style={{
              padding: "0.45rem 1rem", fontSize: "0.875rem", fontWeight: "500",
              border: "1px solid #d1d5db", borderRadius: "0.375rem", cursor: "pointer",
              background: "white", color: "#374151",
            }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button style={confirmBtnStyle} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
